import { Box } from "@mui/material";
import { HeroSection } from "./sections/heroSection";
import { LogoCloud } from "./sections/logoCloud";
import { PrimaryFeatures } from "./sections/primaryFeatures";
import { SecondaryFeatures } from "./sections/secondaryFeatures";
import { StatsSection } from "./sections/statsSection";
import { CTASection } from "./sections/ctaSection";
import { Footer } from "./sections/footer";

export const LandingPage = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#192231",
      }}
    >
      <HeroSection />
      <LogoCloud />
      <PrimaryFeatures />
      <SecondaryFeatures />
      <StatsSection />
      <CTASection />
      <Footer />
    </Box>
  );
};
